import { render, staticRenderFns } from "./DuoSkuInList.vue?vue&type=template&id=58ca2c3f&scoped=true&"
import script from "./DuoSkuInList.vue?vue&type=script&lang=js&"
export * from "./DuoSkuInList.vue?vue&type=script&lang=js&"
import style0 from "./DuoSkuInList.vue?vue&type=style&index=0&id=58ca2c3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca2c3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VSimpleTable})
